<mat-card class="accion-emergencia-dialog">
  <app-card-header
    [title]="titulo"
    subtitle="Registrá cómo terminó la atención"
    icono="task_alt"
  ></app-card-header>
  <mat-divider></mat-divider>

  @if (cargando) {
    <section class="inputs-group">
      <app-loading
        text="Cargando síntomas y diagnósticos…"
        [diameter]="60"
      ></app-loading>
    </section>
  } @else {
    <form [formGroup]="form" (ngSubmit)="guardar()" autocomplete="off">
      <mat-card-content class="card-content-crear cardContentDialog">
        <!-- Código de cierre -->
        <app-content-card title="Código de cierre" icon="emergency" color="red">
          <section class="inputs-group">
            <div class="prioridades">
              @for (item of prioridades; track item.valor) {
                <button
                  type="button"
                  class="prioridad-chip irx-chip"
                  [attr.aria-pressed]="
                    form.value.prioridadCierre === item.valor
                  "
                  (click)="elegirPrioridad(item.valor)"
                >
                  <span class="punto" [style.background]="item.p.color"></span>
                  {{ item.p.label }}
                </button>
              }
            </div>
          </section>
          <section class="inputs-group">
            <span class="ayuda-campo">
              Se abrió con código {{ aperturaLabel }}. Cambialo si la evaluación
              final fue otra.
            </span>
          </section>
        </app-content-card>

        <!-- Clínica -->
        <app-content-card
          title="Síntomas y diagnóstico"
          icon="monitor_heart"
          color="blue"
        >
          <section class="inputs-group">
            <ng-select
              class="custom-ng-select"
              [items]="sintomas"
              placeholder="Síntomas al cierre"
              formControlName="sintomasCierre"
              [multiple]="true"
              [closeOnSelect]="false"
              notFoundText="No hay síntomas cargados"
              appendTo="body"
            ></ng-select>
          </section>
          @for (s of sintomasConComplemento; track s) {
            <section class="inputs-group">
              <div class="complemento">
                <span class="complemento-base">{{ base(s) }}</span>
                <mat-form-field>
                  <mat-label>Completá el síntoma</mat-label>
                  <input
                    matInput
                    [(ngModel)]="complementosSintomas[s]"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </mat-form-field>
              </div>
            </section>
          }
          <section class="inputs-group">
            <ng-select
              class="custom-ng-select"
              [items]="diagnosticos"
              placeholder="Diagnóstico"
              formControlName="diagnostico"
              notFoundText="No hay diagnósticos cargados"
              appendTo="body"
            ></ng-select>
          </section>
          @if (requiereComplemento(form.value.diagnostico)) {
            <section class="inputs-group">
              <div class="complemento">
                <span class="complemento-base">
                  {{ base(form.value.diagnostico!) }}
                </span>
                <mat-form-field>
                  <mat-label>Completá el diagnóstico</mat-label>
                  <input
                    matInput
                    [(ngModel)]="complementoDiagnostico"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </mat-form-field>
              </div>
            </section>
          }
          <section class="inputs-group">
            <span class="ayuda-campo">
              Las opciones se cargan en el menú Síntomas y diagnósticos. Las que
              terminan en «…» piden que las completes.
            </span>
          </section>
        </app-content-card>

        <!-- Observaciones -->
        <app-content-card title="Observaciones" icon="notes" color="orange">
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-icon matPrefix>notes</mat-icon>
              <mat-label>Observaciones</mat-label>
              <textarea
                matInput
                formControlName="observaciones"
                rows="3"
              ></textarea>
            </mat-form-field>
          </section>
        </app-content-card>
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          text="Cancelar"
          icon="close"
          (click)="cerrar()"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          color="primary"
          text="Finalizar"
          icon="task_alt"
          type="submit"
          [disabled]="guardando"
          [loading]="guardando"
        ></app-button>
      </mat-card-actions>
    </form>
  }
</mat-card>
